import { selectors as requestSelectors } from "redux-request-state";

const goalsBase = state => state.goals.all;
export const isLoadingGoals = requestSelectors.isLoading( goalsBase );
export const getGoals = requestSelectors.getData( goalsBase );


const goalsProgressBase = state => state.goals.progress;
export const isLoadingGoalsProgress = requestSelectors.isLoading( goalsProgressBase );
export const getGoalsProgress = requestSelectors.getData( goalsProgressBase );